'use client'

import { MessageSquare } from 'lucide-react'
import { trackEvent, trackLovedPetsConversion } from '@/lib/analytics'

const SMS_BODY = 'Hi Janine, I saw your Pet Aftercare page and would like to talk about my pet.'
// E.164 number (+64) is more reliable than the local 021… form, and the `?&body=`
// separator prefills the message on BOTH iOS (wants &) and Android (wants ?).
export const SMS_HREF = `sms:+64212613600?&body=${encodeURIComponent(SMS_BODY)}`
// Human-readable form of the number for display in buttons/links.
export const PHONE_DISPLAY = '(021) 261 3600'

interface Props {
  variant?: 'hero' | 'closing'
}

export default function LovedPetsCTAs({ variant = 'hero' }: Props) {
  // On the closing CTA the section background is brand blue, so a brand-blue
  // SMS button vanishes — invert it to white/blue for contrast there.
  const smsClasses =
    variant === 'closing'
      ? 'bg-white hover:bg-gray-100 text-[#004da9] shadow-lg shadow-black/10'
      : 'bg-[#004da9] hover:bg-[#003d8a] text-white shadow-lg shadow-[#004da9]/20'

  return (
    <div className="flex">
      <a
        href={SMS_HREF}
        onClick={() => {
          trackEvent('lovedpets_cta_clicked', { channel: 'sms', variant })
          trackLovedPetsConversion({ channel: 'sms', variant })
        }}
        className={`inline-flex items-center justify-center gap-2 text-[17px] font-medium px-7 py-3.5 rounded-full transition-colors ${smsClasses}`}
      >
        <MessageSquare className="w-5 h-5" />
        Text Janine — {PHONE_DISPLAY}
      </a>
    </div>
  )
}
